import contract from "../../../config/mobile_contract.json"

export const CLIENT_CONTRACT = Object.freeze(contract)
